import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const totalPrice =
    cartItems?.reduce((total, item) => total + item.price * item.quantity, 0) ||
    0;
  const totalItems =
    cartItems?.reduce((total, item) => total + item.quantity, 0) || 0;

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-center">
          <Link to="/" onClick={toTop} className="logo-link">
            <div className="logo-icons">
              <i className="fa-solid fa-dog"></i>
              <i className="fa-solid fa-cat"></i>
            </div>
            <div className="logo-text">Pawluna</div>
          </Link>
          <div className="logo-subtext">
            Designed for enrichment · Free delivery over £40 (UK Mainland)
          </div>
        </div>

        <div className="header-right">
          <div className="cart-wrapper">
            <div className="cart-badge">{totalItems}</div>
            <Link to="/cartpage" onClick={toTop} className="cart-icon-wrapper">
              <i className="fa-solid fa-bag-shopping"></i>
            </Link>
          </div>
          <div className="cart-total">£{totalPrice.toFixed(2)}</div>
        </div>
      </div>

      <nav className="header-bottom">
        <ul className="nav-list">
          <li>
            <Link to="/" onClick={toTop}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/shop" onClick={toTop}>
              Shop All
            </Link>
          </li>

          <li>
            <Link to="/about" onClick={toTop}>
              About us
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={toTop}>
              Contact us
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
